import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';

import useStyles from '../useStyles';

const Head = ({
  columns,
  sortBy,
  sortOrder,
  onSort,
  selectable,
  allSelected,
  indeterminate,
  onSelectAll,
  striped,
  dense,
}) => {
  const classes = useStyles();
  const cellClass = classnames(
    classes.cell,
    striped && classes.cellStriped,
    dense && classes.cellDense
  );

  const renderLabel = ({ id, label, sortable }) => {
    if (!label) return null;
    if (!sortable || !onSort) return label;
    return (
      <TableSortLabel
        className={classes.sortLabel}
        active={sortBy === id}
        direction={sortBy === id ? sortOrder : 'asc'}
        onClick={() => onSort(id)}
      >
        {label}
      </TableSortLabel>
    );
  };

  return (
    <TableHead className={classnames(classes.head, striped && classes.headStriped)}>
      <TableRow>
        {selectable && (
          <TableCell padding="checkbox" className={cellClass}>
            <Checkbox
              checked={allSelected}
              indeterminate={indeterminate}
              onChange={onSelectAll}
              inputProps={{ 'aria-label': 'select all rows' }}
            />
          </TableCell>
        )}
        {columns.map((column) => (
          <TableCell
            key={column.id}
            scope="col"
            align={column.align}
            width={column.width}
            className={classnames(cellClass, classes.headCell, dense && classes.headCellDense)}
            sortDirection={sortBy === column.id ? sortOrder : false}
          >
            {renderLabel(column)}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

Head.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.node,
      align: PropTypes.string,
      sortable: PropTypes.bool,
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  sortBy: PropTypes.string,
  sortOrder: PropTypes.oneOf(['asc', 'desc']),
  onSort: PropTypes.func,
  selectable: PropTypes.bool,
  allSelected: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onSelectAll: PropTypes.func,
  striped: PropTypes.bool,
  dense: PropTypes.bool,
};

Head.defaultProps = {
  sortBy: '',
  sortOrder: 'asc',
  onSort: undefined,
  selectable: false,
  allSelected: false,
  indeterminate: false,
  onSelectAll: undefined,
  striped: false,
  dense: false,
};

export default Head;
